// Guía de tallas pop-up para Ana Cristina P.D.
document.addEventListener('DOMContentLoaded', function () {
    // Asegurarse de que el popup esté oculto al inicio
    const overlay = document.getElementById('guia-tallas-overlay');
    if (overlay) {
        // Reset explícito de cualquier estilo que pueda causar flash
        overlay.style.display = 'none';
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
        // Eliminar los estilos inline después de un retraso para permitir que el CSS tome el control
        setTimeout(function () {
            overlay.style.removeProperty('display');
            overlay.style.removeProperty('opacity');
            overlay.style.removeProperty('visibility');
        }, 500);
    }

    // Crear botón de guía de tallas
    function createTallasButton() {
        // Verificar si estamos en la página de producto
        const formSelector = document.querySelector('form[action*="/cart/add"]');
        if (!formSelector) return;

        // Buscar el selector de tallas
        const variantSelectors = formSelector.querySelectorAll('.product-form__input');
        if (!variantSelectors.length) return;

        // Iterar por los selectores buscando uno relacionado con tallas
        variantSelectors.forEach(selector => {
            const label = selector.querySelector('.form__label');
            if (label && (
                label.textContent.toLowerCase().includes('talla') ||
                label.textContent.toLowerCase().includes('size')
            )) {
                // Crear botón si no existe
                if (!selector.querySelector('.guia-tallas-btn')) {
                    const tallasButton = document.createElement('button');
                    tallasButton.id = 'abrir-guia-tallas';
                    tallasButton.className = 'guia-tallas-btn';
                    tallasButton.innerText = 'Guía de tallas';
                    tallasButton.type = 'button';
                    // Insertar después del selector de variantes
                    selector.appendChild(tallasButton);
                }
            }
        });
    }

    // Inicializar eventos
    function initEvents() {
        // Asegurarse de que el botón exista (puede haber sido creado por Liquid o JS)
        if (!document.getElementById('abrir-guia-tallas')) {
            createTallasButton();
        }

        // Abrir pop-up
        document.addEventListener('click', function (e) {
            if (e.target && e.target.id === 'abrir-guia-tallas') {
                e.preventDefault();
                document.getElementById('guia-tallas-overlay').classList.add('active');
                document.body.style.overflow = 'hidden';
            }
        });

        // Cerrar pop-up
        const closeButton = document.getElementById('cerrar-popup');
        if (closeButton) {
            closeButton.addEventListener('click', function () {
                document.getElementById('guia-tallas-overlay').classList.remove('active');
                document.body.style.overflow = '';
            });
        }

        // Cerrar al hacer clic en el overlay
        const overlay = document.getElementById('guia-tallas-overlay');
        if (overlay) {
            overlay.addEventListener('click', function (e) {
                if (e.target === this) {
                    overlay.classList.remove('active');
                    document.body.style.overflow = '';
                }
            });
        }
    }

    // Iniciar
    initEvents();

    // **NUEVA FUNCIONALIDAD: Subir imagen adicional**
    function initImageUpload() {
        const imageUploadContainer = document.getElementById('imagen-adicional-container');
        if (!imageUploadContainer) return;

        const fileInput = document.getElementById('subir-imagen-adicional');
        const preview = document.getElementById('preview-imagen-adicional');
        const removeButton = document.getElementById('remover-imagen-adicional');

        if (fileInput) {
            fileInput.addEventListener('change', function (e) {
                const file = e.target.files[0];
                if (file && file.type.startsWith('image/')) {
                    const reader = new FileReader();
                    reader.onload = function (event) {
                        preview.src = event.target.result;
                        preview.style.display = 'block';
                        removeButton.style.display = 'inline-block';
                    };
                    reader.readAsDataURL(file);
                }
            });
        }

        if (removeButton) {
            removeButton.addEventListener('click', function () {
                fileInput.value = '';
                preview.src = '';
                preview.style.display = 'none';
                removeButton.style.display = 'none';
            });
        }
    }

    // Inicializar la funcionalidad de subida de imagen
    initImageUpload();
});